export default __webpack_public_path__ + "src/images/packages/bundox-safari-lodge/f8ccbd7f9c499620be601f06ee4d482e-1.jpg";